<template>
  <page-section :title="$t('Integrations_Overview_Information')">
    <form-section>
      <b>{{ $t('Integrations_Alira_Field_Endpoint') }}</b>
      : {{ model.params.endpoint }}
    </form-section>
    <integration-tasks-table
      :integration-id="model.id"
      :task-identifiers="['alira_sync_groups']"
    />
  </page-section>
</template>

<script>
import PageSection from '@/common/components/page/PageSection'
import FormSection from '@/common/components/form/FormSection'
import IntegrationTasksTable from '@/modules/integrations/components/IntegrationTasksTable'
export default {
  name: 'AliraOverview',
  components: { IntegrationTasksTable, FormSection, PageSection },
  props: {
    model: {
      required: false
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/types/alira/AliraOverview.vue